import merge from 'lodash/merge'
import { envExternalConfigs } from './external'
import { isPartnerOnline, LoginRedirectPath } from '../resources/searchUtills'

const stageApiKey = '8d3b2848ce5f16aac9016898d5d5721cc47fb81e'
const prodApiKey = 'd538fd2dc47b9df208428854cc991f6646ae3350'

export const OTEL_PRD_API_KEY = prodApiKey

const commonConfig = {
  apiKey: stageApiKey,
  maintenance: {
    enabled: false,
  },
  debug: {
    enableReduxDevTools: true,
    enableNetworkLogging: true,
    networkOptions: {
      /* WARNING: Memory intensive! Only enable for testing or severe bugs. */
      body: true,
    },
  },
  auth: {
    clientId: 'launchpad_npe_im',
    loginRedirect: `${window.location.origin}/auth/login`,
  },
  analytics: {
    url: 'https://stgapi-internal.target.com/firefly_internal_events/v1',
    apiKey: stageApiKey,
    appName: 'LAUNCHPAD',
    retries: 1,
    persistMethod: 'localStorage',
  },
  graphql: {
    // url: 'http://localhost:9001/graphql', //use this only when running locally
    url: 'https://launchpadgraphql.dev.target.com/graphql',
  },
  bulk: {
    url: 'https://itembulkapi-stage.dev.target.com/item_bulk/v2/',
  },
  validation: {
    url: 'https://itemvalidationsapi.dev.target.com/item_validation/v1/',
  },
}

const envConfigs = {
  local: {},
  dev: {
    apiKey: stageApiKey,
  },
  stg: {
    apiKey: stageApiKey,
    graphql: {
      url: 'https://stgapi-internal.target.com/graphql_launchpad/v1',
    },
    bulk: {
      url: 'https://stgapi-internal.target.com/item_bulk/v2/',
    },
    validation: {
      url: ' https://stgapi-internal.target.com/item_validation/v1/',
    },
  },
  prod: {
    apiKey: prodApiKey,
    maintenance: {
      enabled: false,
    },
    debug: {
      enableReduxDevTools: true,
      enableNetworkLogging: false,
      networkOptions: {
        /* WARNING: Memory intensive! Only enable for testing or severe bugs. */
        body: false,
      },
    },
    auth: {
      authorizationUrl: 'https://oauth.iam.target.com/auth/oauth/v2/authorize',
      logoutUrl:
        'https://logonservices.iam.target.com/login/responses/logoff.html',
      clientId: 'launchpad_prod_im',
      loginRedirect: LoginRedirectPath(),
    },
    analytics: {
      url: 'https://api-internal.target.com/firefly_internal_events/v1',
      apiKey: prodApiKey,
      appName: 'LAUNCHPAD',
      retries: 1,
      persistMethod: 'localStorage',
    },
    graphql: {
      url: 'https://api-internal.target.com/graphql_launchpad/v1',
    },
    bulk: {
      url: 'https://api-internal.target.com/item_bulk/v2/',
    },
    validation: {
      url: 'https://api-internal.target.com/item_validation/v1/',
    },
  },
}

const appEnv = process.env.REACT_APP_ENV
const config = envConfigs[appEnv]
let veItemBulkMfeConfig = merge(commonConfig, config)

if (isPartnerOnline()) {
  veItemBulkMfeConfig = merge(
    {},
    veItemBulkMfeConfig,
    envExternalConfigs[appEnv],
  )
}

export default veItemBulkMfeConfig
